import VideosList from "../features/video/VideosList";

const Home = () => {
  return (
    <div>
      <VideosList />
    </div>
  );
};

export default Home;
